import React, { useState, useEffect } from 'react';



const faqs = [
    {
      question: 'What is Instaship App?',
      answer:
        'Instaship is a logistics platform offering seamless intercity transportation of goods. We’ve partnered with reliable Goods Transport Agencies (GTAs) to ensure safe and timely deliveries across India from our designated pickup cities. We provide doorstep pickup services, and door delivery is available based on shipment weight and destination. Everything—from booking to tracking—can be managed directly through our easy-to-use mobile app.',
    },
    {
      question: 'Does Instaship offer intracity or within-city transportation?',
      answer:
        'Currently, Instaship focuses on intercity logistics and does not support intracity or within-city movement of goods. However, we are continuously evolving—stay tuned for future updates!',
    },
    {
      question: 'Which transporter ID should I use for shipments?',
      answer:
        'Use transporter ID: 07AAICI1317H1ZS for all shipments. This is our registered GTA ID, and we operate by sourcing vehicle hire services from our trusted GTA partners.',
    },
    {
      question: 'How are taxes handled for shipments?',
      answer:
        'We operate under the Reverse Charge Mechanism (RCM). This means the party liable to pay for the transportation (either the consignor or consignee) must directly pay 5% GST to the government via their own GST portal.',
    },
    {
      question: 'What documents are required for shipping?',
      answer:
        'You’ll need the following essential documents:\n\n- A Tax Invoice with valid GSTIN details\n- A compliant E-Way Bill, as per legal requirements\n- Any other documentation applicable to the shipment',
    },
    {
      question: 'What is required at the time of receiving goods at the delivery location?',
      answer:
        'At the delivery point, the receiver or consignee must present the consignment note stamped with the official company seal. This is required for proper verification and record-keeping.',
    },
    {
      question: 'How can I request the deletion of my account and personal data?',
      answer:
        'To request deletion of your account and associated personal data, please email us at support@instaship.co.in . Make sure to include your registered mobile number and any other relevant details to help us verify your identity and process your request securely.',
    },

  ];
const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

//   const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);
  
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 940);

  useEffect(() => {
    const handleResize = () => {
    //   setIsMobile(window.innerWidth < 768);
    setIsMobile(window.innerWidth < 940);
    };
  
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section style={{ background: '#fff', padding: isMobile ? '48px 20px' : '80px 24px' }}>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: isMobile ? 36 : 56 }}>
          <p style={{ fontSize: 13, fontWeight: 600, letterSpacing: '0.12em', color: '#3498db', textTransform: 'uppercase', marginBottom: 12 }}>FAQ</p>
          <h2 style={{ fontSize: isMobile ? '1.75rem' : '2.5rem', fontWeight: 800, color: '#0F172A', letterSpacing: '-0.03em', margin: 0 }}>
            Frequently Asked Questions
          </h2>
        </div>
        {faqs.map((faq, index) => (
          <div
            key={index}
            style={{
              marginBottom: 12,
              borderRadius: 12,
              border: `1px solid ${openIndex === index ? '#3498db' : '#e2e8f0'}`,
              background: openIndex === index ? '#f0f8ff' : '#fff',
              overflow: 'hidden',
              transition: 'border-color 0.2s, background 0.2s',
            }}
          >
            <div
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '18px 24px', cursor: 'pointer',
                borderLeft: openIndex === index ? '4px solid #3498db' : '4px solid transparent',
                transition: 'border-color 0.2s',
              }}
              onClick={() => toggleFAQ(index)}
            >
              <h3 style={{ margin: 0, fontSize: isMobile ? 15 : 16, fontWeight: 600, color: openIndex === index ? '#1a6fa8' : '#0F172A', lineHeight: 1.4 }}>
                {faq.question}
              </h3>
              <span style={{
                color: '#3498db', fontSize: 20, lineHeight: 1,
                transform: openIndex === index ? 'rotate(45deg)' : 'rotate(0deg)',
                transition: 'transform 0.25s ease',
                flexShrink: 0, marginLeft: 16,
              }}>+</span>
            </div>
            {openIndex === index && (
              <div style={{ padding: '0 24px 20px 28px' }}>
                <p style={{ margin: 0, fontSize: 14, color: '#475569', lineHeight: 1.75, whiteSpace: 'pre-line' }}>
                  {faq.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
